import "core-js/modules/es.array.iterator.js";
import React from 'react';
export const SELECTION_TABLE_COLUMN_ID = '__selection-checkbox-column__';
export const useTableCheckbox = (hook, header, Component) => {
  hook.visibleColumns.push(columns => [{
    id: SELECTION_TABLE_COLUMN_ID,
    Header: ({
      getToggleAllPageRowsSelectedProps
    }) => /*#__PURE__*/React.createElement(React.Fragment, null, header && /*#__PURE__*/React.createElement("div", {
      className: "table-selection-checkbox-container"
    }, /*#__PURE__*/React.createElement(Component, getToggleAllPageRowsSelectedProps()))),
    Cell: props => {
      const {
        row
      } = props;
      return /*#__PURE__*/React.createElement("div", {
        className: "table-selection-checkbox-container"
      }, /*#__PURE__*/React.createElement(Component, row.getToggleRowSelectedProps()));
    },
    freeze: true,
    disableSortBy: true,
    disableGroupBy: true,
    disableFilters: true,
    minWidth: 65,
    maxWidth: 65
  }, ...columns]);
};